import { nsRemoteCollection } from '@/app/i18n/namespaces';

const REMOTE_COLLECTION_RECONCILIATION_CODE = {
    RECONCILED_TOTALS_CORRECT: { name: 'RECONCILED_TOTALS_CORRECT', entity: 'status.RECONCILED_TOTALS_CORRECT', namespace: nsRemoteCollection, variant: 'green' },
    RECONCILED_TOTALS_INCORRECT: { name: 'RECONCILED_TOTALS_INCORRECT', entity: 'status.RECONCILED_TOTALS_INCORRECT', namespace: nsRemoteCollection, variant: 'red' },
    EMPTY: { name: 'EMPTY', entity: 'status.EMPTY', namespace: nsRemoteCollection, variant: 'gray' },
    NOT_COMPLETED: { name: 'NOT_COMPLETED', entity: 'status.NOT_COMPLETED', namespace: nsRemoteCollection, variant: 'orange' },
    NOT_EMPTY: { name: 'NOT_EMPTY', entity: 'status.NOT_EMPTY', namespace: nsRemoteCollection, variant: 'blue' },
    TOTALS_INVALID: { name: 'TOTALS_INVALID', entity: 'status.TOTALS_INVALID', namespace: nsRemoteCollection, variant: 'red' },
    INTERRUPTED: { name: 'INTERRUPTED', entity: 'status.INTERRUPTED', namespace: nsRemoteCollection, variant: 'orange' }
};

export default REMOTE_COLLECTION_RECONCILIATION_CODE;
